export default "__VITE_ASSET__CpNPYHhD__"